export const USER_DATA_LOCAL_STORAGE_KEY = 'userData'

export const GET_USER_DATA_AKAMAI_ENDPOINT = '/user-data'
export const SET_USER_DATA_AKAMAI_ENDPOINT = '/user-data/set'
